import { authClient } from "@/lib/auth-client";

export function signInAnonymous() {
  return authClient.signIn.anonymous();
}
